module.exports = __webpack_public_path__ + "assets/img/btn-download-hover-b6b29ef2.png";